// extracted by mini-css-extract-plugin
export default {"emptyStateDivBox":"emptyStateDivBox__ZK9FL","teslaListBody":"teslaListBody__FPGt5"};